module.exports = __webpack_public_path__ + "static/media/enterprise4.700f9d5a.png";